import { render, staticRenderFns } from "./PageHeadlineWithFourSteps.vue?vue&type=template&id=c8013564&scoped=true&"
import script from "./PageHeadlineWithFourSteps.vue?vue&type=script&lang=js&"
export * from "./PageHeadlineWithFourSteps.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadlineWithFourSteps.vue?vue&type=style&index=0&id=c8013564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8013564",
  null
  
)

export default component.exports